import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import de from './locales/de.json'

export type MessageSchema = typeof en

const messages = {
  en,
  de,
}

const supportedLocales = ['en', 'de']

// Get the saved language from localStorage, falling back to the browser locale
const getSavedLanguage = (): string => {
  if (typeof window !== 'undefined') {
    const saved = localStorage.getItem('language')
    if (saved && supportedLocales.includes(saved)) return saved

    const browserLang = navigator.language?.split('-')[0]
    if (browserLang && supportedLocales.includes(browserLang)) return browserLang
  }
  return 'de'
}

const i18n = createI18n<MessageSchema, keyof typeof messages>({
  legacy: false,
  locale: getSavedLanguage(),
  fallbackLocale: 'de',
  messages,
})

export const setLanguage = (lang: string) => {
  const locale = i18n.global.locale as any
  if (locale) {
    locale.value = lang
    localStorage.setItem('language', lang)
  }
}

export const getAvailableLanguages = () => [
  { code: 'en', name: 'English' },
  { code: 'de', name: 'Deutsch' },
]

export default i18n
